
(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "May", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Oct", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.465"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.465",
    "da": "static-7.465",
    "de": "static-7.465",
    "el": "static-7.465",
    "en": "static-7.465",
    "es-mx": "static-7.465",
    "es": "static-7.465",
    "fi": "static-7.465",
    "fr": "static-7.465",
    "it": "static-7.465",
    "ja": "static-7.465",
    "ko": "static-7.465",
    "nl": "static-7.465",
    "no": "static-7.465",
    "pl": "static-7.465",
    "pt-br": "static-7.465",
    "sv": "static-7.465",
    "zh-cn": "static-7.465",
    "zh-hk": "static-7.465"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.465'}); }
})();


